import axios from "axios";
import { showAlert } from "./alert";

export const buildPallet = async (data, type) => {
  try {
    const res = await axios({
      method: "POST",
      url: "/api/v1/pallets",
      data,
    });

    if (res.data.status === "success") {
      showAlert("success", `Upload successful!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
    next();
  }
};

export const deletePallet = async (data, type) => {
  try {
    const res = await axios({
      method: "DELETE",
      url: `/api/v1/pallets/${data}`,
      data,
    });

    showAlert("success", `Pallet ${data} deleted!`);
    window.setTimeout(() => {
      location.assign("/palletHub");
    }, 1000);
  } catch (err) {
    showAlert("error", err.response.data.message);
    next();
  }
};
